import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_LANDING_TEMPLATE_STATE,
});

export const syncLandingTemplates = () => ({
  type: types.SYNC_LANDING_TEMPLATES.REQUEST,
});

export const syncLandingTemplatesSuccess = (templates) => ({
  type: types.SYNC_LANDING_TEMPLATES.SUCCESS,
  templates,
});

export const syncLandingTemplatesFailure = (error) => ({
  type: types.SYNC_LANDING_TEMPLATES.FAILURE,
  error,
});

export const saveLandingTemplate = (template) => ({
  type: types.SAVE_LANDING_TEMPLATE.REQUEST,
  template,
});

export const saveLandingTemplateSuccess = () => ({
  type: types.SAVE_LANDING_TEMPLATE.SUCCESS,
});

export const saveLandingTemplateFailure = (error) => ({
  type: types.SAVE_LANDING_TEMPLATE.FAILURE,
  error,
});

export const archiveLandingTemplate = (templateId) => ({
  type: types.ARCHIVE_LANDING_TEMPLATE.REQUEST,
  templateId,
});

export const archiveLandingTemplateSuccess = () => ({
  type: types.ARCHIVE_LANDING_TEMPLATE.SUCCESS,
});

export const archiveLandingTemplateFailure = (error) => ({
  type: types.ARCHIVE_LANDING_TEMPLATE.FAILURE,
  error,
});
